import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import { getLoadedDate, getSideBySideApptsWithShopForBarber } from '../selectors';
import { deleteBlockTime } from '../../../../barbers/actions';
import withPermissions from '../../../../../auth/utils/withPermissions';
import SideBySideCalendarWidget from '../sideBySideCalendarWidget';
import { getAppointment } from '../../../actions';
import withMinInterval from '../../../../../common/hoc/withMinInterval';

const makeMapStateToProps = () => {
  const appointmentSelector = getSideBySideApptsWithShopForBarber();
  return (state, props) => {
    return {
      timezone: state.auth.timezone,
      user: state.auth.user,
      loadedDate: getLoadedDate(state),
      appointments: appointmentSelector(state, props),
    };
  };
};

const mapDispatchToProps = {
  deleteTime: deleteBlockTime,
  fetchAppointment: getAppointment,
};

export default compose(
  withPermissions,
  withMinInterval,
  connect(makeMapStateToProps, mapDispatchToProps),
  branch(props => !props.loadedDate, renderNothing)
)(SideBySideCalendarWidget);
